import Vue from 'vue'
import store from '@/store'

const plugins = {};

export default function cordovaLoader(cb) {

  document.addEventListener('deviceready', () => {
    
    store.commit('global/SET_DEVICE', true)

  }, false);
  
  cb(plugins)

}


// WEBPACK FOOTER //
// ./src/loader/cordova.js